// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

// Components
import Container from '../../container/container';
import BlogPostFeaturedImage from '../blogPostFeaturedImage/blogPostFeaturedImage';

// Styles
import BlogPostExcerptStyles from './blogPostExcerpt.styles';

export default function BlogPostExcerpt({ excerpt, featuredImage }) {
  const noImage = !featuredImage?.node?.gatsbyImage;

  const parsedExcerpt = parse(excerpt);

  return (
    <BlogPostExcerptStyles noImage={noImage}>
      {featuredImage?.node?.gatsbyImage && (
        <div className="featured-img-wrap">
          <BlogPostFeaturedImage featuredImage={featuredImage} fit="desktop" />
        </div>
      )}

      <div className="excerpt-wrap">
        <Container
          fullWidth
          flex
          alignItems="center"
          justifyContent={noImage ? 'center' : 'flex-end'}
        >
          <div className="excerpt-inner">{parsedExcerpt}</div>
        </Container>
      </div>
    </BlogPostExcerptStyles>
  );
}

BlogPostExcerpt.propTypes = {
  excerpt: PropTypes.string,
  featuredImage: PropTypes.shape({
    altText: PropTypes.string,
    node: PropTypes.shape({
      gatsbyImage: PropTypes.shape({}),
    }),
  }),
};

BlogPostExcerpt.defaultProps = {
  excerpt: '',
  featuredImage: null,
};
